/**
 * ============================================================================
 * DASHBOARD ROUTER
 * Une seule vue tableau de bord, déduite de la fonction d'encadrement puis du pôle métier,
 * sans onglets ni ?vue=
 */

import PageLoader from './PageLoader';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import EntityDashboard from './EntityDashboard';
import { resolveDashboardPoleFromUser } from '../utils/dashboardPoles';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const DashboardRouter = () => {
    const navigate = useNavigate();

    const [freshUser, setFreshUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUser = useCallback(async () => {
        const stored = localStorage.getItem('user');
        if (!stored) {
            navigate('/login');
            return;
        }
        let storedUser;
        try {
            storedUser = JSON.parse(stored);
        } catch {
            navigate('/login');
            return;
        }
        const userId = storedUser.id || storedUser.userId;
        if (!userId) {
            navigate('/login');
            return;
        }

        setLoading(true);
        try {
            const res = await axios.get(`${API_URL}/users/${userId}`, {
                withCredentials: true,
                headers: { Accept: 'application/ld+json' },
            });
            setFreshUser(res.data || storedUser);
        } catch {
            setFreshUser(storedUser);
        } finally {
            setLoading(false);
        }
    }, [navigate]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    const effectivePole = resolveDashboardPoleFromUser(freshUser);

    if (loading) return <PageLoader text="Chargement du tableau de bord…" />;
    if (!freshUser) return null;

    return (
        <div className="ed-dashboard-route">
            <EntityDashboard dashboardUser={freshUser} dashboardPole={effectivePole} />
        </div>
    );
};

export default DashboardRouter;
